<template>
  <!-- <section class="section_area section_inner section_innertop section_innerbottom"> -->
		<!-- <div  v-bind:class="pass.class">
			<a class="page_con prev" v-on:click="onClickPagerPreNo('N',pass.pageNo)" v-bind:href="pass.href" >이전 페이지</a>
				<div class="number">
				    <input type="number" v-model="pass.pageNo" class="form_style">
							/
				    <span class="total">{{pass.endSize}}</span>
				</div>
			<a class="page_con next" v-on:click="onClickPagerNxtNo('Y',pass.pageNo)" v-bind:href="pass.href">다음 페이지</a>
		</div> -->
	<!-- </section> -->

    <div v-bind:class="pass.class">
      <a class="page_con first" v-bind:href="pass.href" v-on:click="onClickPagerNo(0)" @keydown.enter.prevent="onClickPagerNo(0)" tabindex="9000">첫 페이지</a>
      <a class="page_con prev"  v-bind:href="pass.href" v-on:click="onClickPagerNo(pass.startBlock-1)" @keydown.enter.prevent="onClickPagerNo(pass.startBlock-1)" tabindex="9001">이전 페이지</a>
      <ul class="page_num">
        <li :class="{on:item == (pass.pageNo==0 ? 1:pass.pageNo)}" v-for="(item, index) in pass.list" v-bind:key="item">
          <a v-on:click="onClickPagerNo(item)" v-bind:href="pass.href" :tabindex="9002+index" @keydown.enter.prevent="onClickPagerNo(item)">{{item}}</a>
        </li>
      </ul>
      <a class="page_con next" v-bind:href="pass.href" v-on:click="onClickPagerNo(pass.nextBlock)" @keydown.enter.prevent="onClickPagerNo(pass.nextBlock)" tabindex="9020">다음 페이지</a>
      <a class="page_con last" v-bind:href="pass.href" v-on:click="onClickPagerNo(pass.endSize)" @keydown.enter.prevent="onClickPagerNo(pass.endSize)" tabindex="9021">마지막 페이지</a>
    </div>

</template>
<script>
  export default{
    props:['pass']
    ,methods:{
      /*
       onClickPagerPreNo:function(value,n){
         if(n <= 1){
            // alert("처음페이지입니다."); 
            this.pass.pageNo=1;  
            return; 
        }
        
        this.pass.pageNo = n--;
        this.pass.callBack(n);
      }
      ,onClickPagerNxtNo:function(value,n){
        if(n >= this.pass.endSize){
            // alert("마지막페이지입니다."); 
            this.pass.pageNo = this.pass.endSize; 
            return;
        }

        this.pass.pageNo = n++;
        this.pass.callBack(n);
      }
      */
      onClickPagerNo:function(n){
        this.pass.pageNo = n==0 ? 1:n;
        this.pass.callBack(n);
      }

     ,createPager:function(pager,vm,cbType){
        pager.callBackType=cbType;
        let _list=[];
        let _prePager = parseInt(pager.totalSize-1);
        let _nxtPager = parseInt(pager.rowSize);
        let _endPager = parseInt( (_prePager / _nxtPager) + 1 );

      //  let _endPagerNo=parseInt((pager.totalSize-1)/pager.rowSize)+1;
        let _endPagerNo = (_endPager == 0) ? 1 : _endPager;
        let _startBlock=parseInt((pager.pageNo-1)/pager.blockSize)*pager.blockSize+1;
        let index=0;
        let _endBlock=0;
        let _nextBlock=0;

        for(let i=_startBlock;i<=_endPagerNo;i++){
  
          if(index<pager.blockSize){
            _list.push(i);
            _endBlock=i;
            if(i<_endPagerNo){
              _nextBlock=i+1;
            }
            // else{
            //   _nextBlock=0;
            // }
            index++;
          }else{
            break; 
          }
        }//end for
       
        pager.list=_list;
        pager.model=vm;
        pager.startBlock=_startBlock;
        pager.nextBlock=_nextBlock;
        pager.endSize = _endPagerNo;
      
        return pager;
      }
    }
  }
</script>